import { all } from "redux-saga/effects";

import * as failedtoclose from "./failedtoclose";

export function* rootSaga() {
  yield all([
    failedtoclose.watchLiveRefresh(),
  ]);
}